import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { ReduxService } from 'dashboard-services/services';

import Tag from './Tag';

const EMPTY_OBJ = {};

const Tags = ({ groupName = undefined, metadata = EMPTY_OBJ, name, onChange, symbol = EMPTY_OBJ }) => {
  const removeSymbolKey = useCallback(key => {
          const newS = ReduxService.updateObject(symbol)
          delete newS[key]
          onChange({
            groupName,
            symbol: newS,
            metadata
          }, name)
        }, [groupName, metadata, name, onChange, symbol]),
        removeMetadataKey = useCallback(key => {
          const newM = ReduxService.updateObject(metadata)
          delete newM[key]
          onChange({
            groupName,
            symbol,
            metadata: newM
          }, name)
        }, [groupName, metadata, name, onChange, symbol])

  return (
    <div 
        className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter__row"
        style={{ marginBottom: 16, display: "block" }}
    >
      {Object.entries(symbol || {}).map(([key, value]) => (
        <Tag
            key={key}
            onClear={() => removeSymbolKey(key)}
            tagKey={key}
            value={value}
        />
      ))}
      {Object.entries(metadata || {}).map(([key, value]) => (
        <Tag
            key={key}
            onClear={() => removeMetadataKey(key)}
            tagKey={key}
            value={value}
        />
      ))}
    </div>
  )
}

Tags.propTypes = {
  groupName: PropTypes.string,
  metadata: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  symbol: PropTypes.object
}

export default memo(Tags);